import { useState } from "react";
import { Alert, Box, Button, Container, Grid, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { forgotPassword, resetPassword } from "../../axios/axiosFunctions";
import bgImage from '../../assets/images/LoginAdminBackground.png';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1: email, 2: code + new password
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleRequestCode = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    const res = await forgotPassword(email);
    setLoading(false);

    if (res.msg) {
      setMessage(res.msg);
      setStep(2);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setLoading(true);
    const res = await resetPassword(email, code, newPassword);
    setLoading(false);

    if (res.msg === "Password has been reset successfully.") {
      setMessage(res.msg);
      setTimeout(() => navigate("/admin"), 2000);
    } else {
      setError(res.msg);
    }
  };

  return (
    <Container maxWidth={false} sx={{ backgroundImage: `url(${bgImage})`, backgroundSize: "cover" }}>
      <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" sx={{ height: { xs: "calc(100vh - 88px)", sm: "calc(100vh - 96px)" } }}>
        <Typography variant="h6" color="secondary">RESET PASSWORD</Typography>

        <Box sx={{ margin: "20px 0px", maxWidth: 400, width: "100%" }}>
          {step === 1 && (
            <form onSubmit={handleRequestCode}>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Enter your admin email and we'll send you a reset code.
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <TextField
                    required
                    fullWidth
                    type="email"
                    label="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Button
                type="submit"
                sx={{ marginTop: "20px", marginBottom: "10px" }}
                size="large"
                fullWidth
                variant="contained"
                color="secondary"
                disabled={loading}
              >
                {loading ? "SENDING..." : "SEND RESET CODE"}
              </Button>
            </form>
          )}

          {step === 2 && (
            <form onSubmit={handleResetPassword}>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Enter the 6-digit code sent to your email and your new password.
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <TextField
                    required
                    fullWidth
                    label="6-digit code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    inputProps={{ maxLength: 6 }}
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    required
                    fullWidth
                    type="password"
                    label="New password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    required
                    fullWidth
                    type="password"
                    label="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Button
                type="submit"
                sx={{ marginTop: "20px", marginBottom: "10px" }}
                size="large"
                fullWidth
                variant="contained"
                color="secondary"
                disabled={loading}
              >
                {loading ? "RESETTING..." : "RESET PASSWORD"}
              </Button>
              <Button
                size="small"
                onClick={() => { setStep(1); setCode(""); setError(""); setMessage(""); }}
                sx={{ mt: 1 }}
              >
                Resend code
              </Button>
            </form>
          )}

          {message && <Alert sx={{ marginTop: "15px" }} severity="success">{message}</Alert>}
          {error && <Alert sx={{ marginTop: "15px" }} severity="error">{error}</Alert>}

          <Button
            size="small"
            onClick={() => navigate("/admin")}
            sx={{ mt: 2 }}
          >
            Back to Login
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
